let recaptchaToken: string | null = null

export const setRecaptchaToken = (token: string | null) => {
  recaptchaToken = token
}

export const getRecaptchaToken = () => recaptchaToken
